<div class="rtd-container">

  <!-- ── Header ─────────────────────────────────────────────────────────────── -->
  <div class="rtd-header">
    <div class="rtd-header__left">
      <h2 class="rtd-title">{{ 'bikeshop.receipt_template.list.title' | translate }}</h2>
      <p class="rtd-subtitle">{{ 'bikeshop.receipt_template.list.subtitle' | translate }}</p>
    </div>
    <div class="rtd-header__right">
      <!--<label class="btn-import">
    <i class="pi pi-upload"></i> Import
    <input type="file" accept=".json" hidden (change)="onFileImport($event)" />
  </label>-->
      <hub-button [size]="'lg'" [style]="'outline'" [text]="'bikeshop.receipt_template.list.create_new' | translate" [icon]="'plus'" (buttonClick)="createNew()"></hub-button>
      <!--<button pButton icon="pi pi-plus" label="Create New Template" class="p-button-primary" (click)="createNew()"></button>-->
    </div>
  </div>

  <!-- ── Filters ────────────────────────────────────────────────────────────── -->
  <div class="rtd-filters">
    <span class="p-input-icon-left" style="min-width:350px;">
      <i class="pi pi-search"></i>
      <!--<input type="text" pInputText placeholder="Search templates…" [(ngModel)]="searchText" (ngModelChange)="applyFilter()" />-->
      <hub-input [label]="'bikeshop.receipt_template.list.search_placeholder' | translate" [(ngModel)]="searchText" (ngModelChange)="applyFilter()"
                 [iconColor]="'#888888'" [icon]="'search'" [allowClear]="true"></hub-input>
    </span>

    <!--<p-dropdown
      [options]="typeFilterOptions"
      [(ngModel)]="selectedTypeFilter"
      optionLabel="label"
      optionValue="value"
      (onChange)="applyFilter()"
      styleClass="rtd-type-filter">
    </p-dropdown>-->
  </div>

  <!-- ── Table ──────────────────────────────────────────────────────────────── -->
  <p-table
    [value]="filteredTemplates"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50]"
    styleClass="p-datatable-sm p-datatable-striped"
    emptyMessage="'bikeshop.receipt_template.list.empty_table_message' | translate">

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columns">{{ col.header }}</th>
        <th style="width: 180px">{{ 'bikeshop.receipt_template.list.col_actions' | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-template>
      <tr>
        <!-- Name -->
        <td class="rtd-name-cell" (click)="editTemplate(template)" style="cursor:pointer">
          <span class="rtd-template-name">{{ template.name }}</span>
        </td>

        <!-- Type -->
        <td>
          <span class="rtd-badge" [class.rtd-badge--dispatch]="template.type === 'THIRD_PARTY_DISPATCH'">
            {{ getTypeLabel(template.type) }}
          </span>
        </td>

        <!-- Dimensions -->
        <td class="rtd-dim-cell">{{ getDimensions(template) }}</td>

        <!-- Active -->
        <td>
          <div class="rtd-default-cell">
            <p-inputSwitch [ngModel]="template.isActive"
                           [disabled]="template.isGlobalDefault"
                           (onChange)="onActiveChange(template, $event)">
            </p-inputSwitch>
          </div>
        </td>

        <!-- Default -->
        <td>
          <div class="rtd-default-cell">
            <p-inputSwitch
              [ngModel]="template.isGlobalDefault"
              (onChange)="onDefaultChange(template, $event)">
            </p-inputSwitch>
          </div>
        </td>

        <!-- Last Updated -->
        <td>{{ template.updatedAt | date:'dd MMM yyyy' }}</td>

        <!-- Actions -->
        <td>
          <div class="rtd-actions">
            <hub-button [size]="'lg'" [style]="'outline'" [icon]="'pencil'" (buttonClick)="editTemplate(template)"></hub-button>
            <hub-button [size]="'lg'" [style]="'outline'" [icon]="'copy'" (buttonClick)="duplicateTemplate(template)"></hub-button>
            <hub-button [size]="'lg'" [style]="'outline'" [icon]="'trash'" (buttonClick)="deleteTemplate(template)"></hub-button>
            <!--<button pButton icon="pi pi-pencil" class="p-button-text p-button-sm" pTooltip="Edit" (click)="editTemplate(template)"></button>
            <button pButton icon="pi pi-copy" class="p-button-text p-button-sm" pTooltip="Duplicate" (click)="duplicateTemplate(template)"></button>
            <button pButton icon="pi pi-download" class="p-button-text p-button-sm" pTooltip="Export"    (click)="exportTemplate(template)"></button>
            <button pButton icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger" pTooltip="Delete" (click)="deleteTemplate(template)"></button>-->
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- ── Empty State ────────────────────────────────────────────────────────── -->
  <div class="rtd-empty" *ngIf="!loading && filteredTemplates.length === 0 && templates.length === 0">
    <i class="pi pi-file rtd-empty__icon"></i>
    <h3>{{ 'bikeshop.receipt_template.list.no_templates_title' | translate }}</h3>
    <p>{{ 'bikeshop.receipt_template.list.no_templates_subtitle' | translate }}</p>
    <!--<button pButton label="Create First Template" icon="pi pi-plus" (click)="createNew()"></button>-->
    <hub-button [size]="'lg'" [style]="'outline'" [text]="'bikeshop.receipt_template.list.create_first' | translate" [icon]="'plus'" (buttonClick)="createNew()"></hub-button>
  </div>

</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
